<div class="content-pane">
  @switch (state()) {
    @case ('initial') {
      <!-- intentionally render nothing if the initial search hasn't begun -->
    }
    @case ('loading') {
      <app-generic-tile-list-skeleton />
    }

    @case ('results') {
      <div appInfiniteScroll (infiniteScroll)="onInfiniteScroll($event)">
        <app-generic-tile-list [tiles]="tiles() ?? []"></app-generic-tile-list>
        <div appInfiniteScrollSentinel class="load-trigger"></div>
      </div>
    }

    @case ('empty') {
      <div class="content-pane">
        <div class="no-results-header">No results found</div>
        <p>Please try a new search or change any applied filters.</p>
      </div>
    }
  }
</div>
